import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";

import Section from "../layout/Section";
import { getBetsState, getWinnerPlusMatches } from "../store/selectors/betData";
import InPageMD from "./InPageMD";

import { buildMatchGroups } from "../utils/betUtils";
import { renderMatchGroupWithSport } from "../utils/render";

const useStyles = makeStyles({
  root: {
    backgroundColor: "#EDF0F0",
    padding: "16px 14px"
  },
  empty: {
    textAlign: "center",
    padding: "30px 0",
    fontSize: "14px",
    fontWeight: "600",
    color: "#17214d"
  }
});

function PreMatchPlus(props) {
  const { bst, matches, t } = props;
  const classes = useStyles();

  const ms = Object.values(matches);
  const groups = buildMatchGroups(ms, "matchDateTime", { winnerPlus: true });

  return (
    <Section doRender={[matches]}>
      <InPageMD>
        <div className={classes.root}>
          {groups.length > 0 ? (
            groups.map(g => renderMatchGroupWithSport(g, bst))
          ) : (
            <div className={classes.empty}>{t("There are no Winner Plus matches")}</div>
          )}
        </div>
      </InPageMD>
    </Section>
  );
}

PreMatchPlus.propTypes = {
  idSport: PropTypes.string
};

PreMatchPlus.defaultProps = {
  idSport: "0"
};

const mapStateToProps = (state, props) => {
  const bst = getBetsState(state);

  return {
    bst: bst,
    idSport: bst.navSports.preMatch,
    matches: getWinnerPlusMatches(state)
  };
};

export default withTranslation()(connect(mapStateToProps)(PreMatchPlus));
